/* eslint-disable array-callback-return */
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { ColumnDefinitionType } from '../../components/UIelements/GenericTable/genericTableTypes';
import GenericTable from '../../components/UIelements/GenericTable';
import * as Styled from './styles';
import PrimaryButton from '../../components/FormElements/PrimaryButton';
import { SerialNumbersModel } from '../../models/serial-numbers';

type SerialNumbersColumnTypes = {
  id: number,
  companyId: number,
  serialNumber: string,
  userId: number,
  creationDate: string
  model: string;
  conect: boolean;
  equipmentName: string;
  equipmentVersion: string;
  edit: boolean;
  delete: boolean;
}

const columns: ColumnDefinitionType<
  SerialNumbersColumnTypes,
  keyof SerialNumbersColumnTypes
>[] = [
    {
      key: 'serialNumber',
      gridArea: 'title',
      header: 'equipment.Número de série',
      isSortable: true,
      width: '24%',
    },
    {
      key: 'model',
      gridArea: 'data1',
      header: 'company.Modelo',
      isSortable: false,
      width: '12%',
    },
    {
      key: 'equipmentName',
      gridArea: 'data2',
      header: 'equipment.nome',
      isSortable: false,
      width: '20%',
    },
    {
      key: 'equipmentVersion',
      gridArea: 'data3',
      header: 'equipment.Versão',
      isSortable: false,
      width: '12%',
    },
    {
      key: 'creationDate',
      gridArea: 'data4',
      header: 'company.Cadastro',
      isSortable: true,
      width: '12%',
    },
    {
      key: 'conect',
      gridArea: 'data5',
      header: 'company.Conectado',
      isSortable: false,
      width: '12%',
    },
    {
      key: 'edit',
      gridArea: 'data6',
      header: ' ',
      isSortable: false,
      width: '3%',
    },
    {
      key: 'delete',
      gridArea: 'data7',
      header: ' ',
      isSortable: false,
      width: '3%',
    }
  ];

type ModalProps = {
  serialNumbers: any[];
  selectSerialNumber: (value: number) => void;
  serialNumberCheck: number[];
  showModalDeleteSerialNumber: () => void;
  showModalUpdateSerialNUmber: () => void;
  selectedMarker: React.Dispatch<React.SetStateAction<number[]>>;
  onScroll: (e: React.UIEvent<HTMLDivElement>) => void;
};

const TableSerialNumbers: React.FC<ModalProps> = ({
  serialNumbers,
  selectSerialNumber,
  serialNumberCheck,
  showModalDeleteSerialNumber,
  showModalUpdateSerialNUmber,
  selectedMarker,
  onScroll
}) => {
  const intl = useIntl();
  const [columnOrder, setColumnOrder] = useState<keyof SerialNumbersColumnTypes>('id');


  const getFormattedList = (
    equipmentList: SerialNumbersColumnTypes[],
    columnOrder: keyof SerialNumbersColumnTypes,
  ): SerialNumbersColumnTypes[] => {
    const orderedList = [...equipmentList].sort((a, b) => {
      switch (columnOrder) {
        case 'serialNumber':
          return a.serialNumber.localeCompare(b.serialNumber, undefined, { sensitivity: 'base' });
        case 'creationDate':
          return a.creationDate.localeCompare(b.creationDate, undefined, { sensitivity: 'base' });
        default:
          return a.id > b.id ? 1 : a.id < b.id ? -1 : 0;
      }
    });

    const formattedList = orderedList.map(equipment => {
      const formattedEquipment = { ...equipment };
      return formattedEquipment;
    });

    return formattedList;
  };

  const formattedEquipmentList = getFormattedList(
    serialNumbers,
    columnOrder
  );

  const handleOrderTable = useCallback(
    (columnName: keyof SerialNumbersColumnTypes) => {
      setColumnOrder(columnName);
    },
    []
  );

  const handleVisibleMarkers = useCallback((id: number, isChecked: boolean) => {
    if (id === 0 && isChecked) {
      const allVisibleIds = serialNumbers
        .map((obj: SerialNumbersModel) => obj.id)
        .filter((id): id is number => id != null);
      
      selectedMarker([0, ...allVisibleIds]); 
    } else if (id === 0 && !isChecked) {
      selectedMarker([]);
    } else {
      selectedMarker((prevState) =>
        isChecked
          ? prevState.includes(id)
            ? prevState
            : [...prevState, id]
          : prevState.filter((value) => value !== id)
      );
    }
  }, [serialNumbers, selectedMarker]);

  const handleClick = (id: number, typeOptions?: string) => {
    selectSerialNumber(id);
    if (typeOptions === "delete") {
      selectedMarker([]);
      showModalDeleteSerialNumber();
    } else {
      showModalUpdateSerialNUmber();
    }
  };

  return (
    <>
      <GenericTable
        className='serialNumbers-table'
        data={formattedEquipmentList}
        columns={columns}
        clickUpdate={handleClick}
        onOrderTable={handleOrderTable}
        showMobileHeaders
        checkboxAll={true}
        checkbox={{
          show: true,
          action: handleVisibleMarkers,
          selectedList: serialNumberCheck
        }}
        onScroll={onScroll}
      />

      {serialNumberCheck.length > 0 && (
        <>
          <Styled.InfoDelete>
            {intl.formatMessage({ id: 'company.SELECIONE EQUIPAMENTOS PARA EXCLUIR' })}
          </Styled.InfoDelete>
          <Styled.DivButton className='optionButtons'>
            <PrimaryButton type='button' size='buttonModal' model='confirmation-gradient-modal' width='108px' onClick={() => showModalDeleteSerialNumber()}>
              {intl.formatMessage({ id: 'menus.Excluir' })}
            </PrimaryButton>
            <PrimaryButton type='button' size='buttonModal' model='cancellation' width='108px' onClick={() => selectedMarker([])}>
              {intl.formatMessage({ id: 'menus.CANCELAR' })}
            </PrimaryButton>
          </Styled.DivButton>
        </>
      )}
    </>
  );
}

export default TableSerialNumbers
